import { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { ShareButtons } from "./ShareButtons";
import { lockScroll, unlockScroll } from "../lib/scrollLock";

// z-[10000] : AU-DESSUS des pilules flottantes (Modifier la page / Soumission, z-9990,
// retour-en-haut z-9980) — sinon elles recouvrent la rangée de partage en mobile.
export function PhotoLightbox({ photos, index, onClose, onNavigate }) {
  const photo = index != null ? photos[index] : null;

  useEffect(() => {
    if (!photo) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onNavigate((index - 1 + photos.length) % photos.length);
      if (e.key === "ArrowRight") onNavigate((index + 1) % photos.length);
    };
    window.addEventListener("keydown", onKey);
    lockScroll();  // gèle le fond (Lenis + CSS) pendant la visionneuse
    return () => {
      window.removeEventListener("keydown", onKey);
      unlockScroll();
    };
  }, [photo, index, photos.length, onClose, onNavigate]);

  if (!photo) return null;
  const absUrl = new URL(photo.src, window.location.origin).href;
  const prev = () => onNavigate((index - 1 + photos.length) % photos.length);
  const next = () => onNavigate((index + 1) % photos.length);

  return (
    <div
      data-testid="photo-lightbox"
      className="fixed inset-0 z-[10000] bg-ink/95 backdrop-blur-md flex flex-col items-center justify-center p-4 pt-16"
      onClick={onClose}
    >
      <button
        data-testid="lightbox-close" onClick={onClose}
        className="absolute top-5 right-5 w-11 h-11 rounded-full border border-ivory/25 text-ivory/70 hover:border-gold hover:text-gold flex items-center justify-center transition-colors duration-300"
      >
        <X className="w-5 h-5" />
      </button>
      {photos.length > 1 && (
        <>
          <button
            data-testid="lightbox-prev" onClick={(e) => { e.stopPropagation(); prev(); }}
            className="absolute left-3 md:left-8 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full border border-ivory/25 text-ivory/70 hover:border-gold hover:text-gold flex items-center justify-center transition-colors duration-300"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            data-testid="lightbox-next" onClick={(e) => { e.stopPropagation(); next(); }}
            className="absolute right-3 md:right-8 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full border border-ivory/25 text-ivory/70 hover:border-gold hover:text-gold flex items-center justify-center transition-colors duration-300"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </>
      )}
      <img
        data-testid="lightbox-image" src={photo.src} alt={photo.caption || ""}
        className="max-h-[70vh] max-w-full object-contain rounded-lg border border-ivory/10"
        onClick={(e) => e.stopPropagation()}
      />
      {photo.caption && (
        <p data-testid="lightbox-caption" className="mt-4 text-champagne font-serif italic text-center max-w-2xl"
          onClick={(e) => e.stopPropagation()}>
          {photo.caption}
        </p>
      )}
      <div className="mt-5" onClick={(e) => e.stopPropagation()}>
        <ShareButtons title={photo.caption || "Mr Trophée"} url={absUrl} />
      </div>
    </div>
  );
}
